/* MAD — Coleção: filtros, ordenação, carregar mais e gaveta de filtros (sections/main-collection-product-grid.liquid) */
(function () {
  if (customElements.get('tp-mad-colecao')) return;

  const MOBILE_QUERY = '(max-width: 1023px)';

  class TpMadColecao extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.drawer = this.querySelector('[data-drawer]');
      this.openButton = this.querySelector('[data-open]');
      this.requestId = 0;

      if (window.matchMedia(MOBILE_QUERY).matches) {
        this.querySelectorAll('details[data-open-mobile]').forEach((details) => {
          details.open = details.dataset.openMobile === 'true';
        });
      }

      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeyup = this.onKeyup.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keyup', this.onKeyup);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      document.documentElement.classList.remove('tp-mad-colecao-lock');
    }

    onChange(event) {
      const target = event.target;

      if (target.matches('[data-sort]')) {
        const label = this.querySelector('[data-sort-label]');
        if (label) label.textContent = target.selectedOptions[0].textContent.trim();
        this.update();
        return;
      }

      if (target.matches('[data-price]')) {
        const options = target.closest('.tp-mad-filtro__options');
        options.querySelectorAll('[data-price]').forEach((input) => {
          if (input !== target) input.checked = false;
        });
        options.querySelector('[data-price-gte]').value = target.checked ? target.dataset.min : '';
        options.querySelector('[data-price-lte]').value = target.checked ? target.dataset.max : '';
      }

      if (target.closest('[data-filter-form]')) this.update();
    }

    onClick(event) {
      const target = event.target;

      if (target.closest('[data-open]')) {
        this.openDrawer();
        return;
      }

      if (target.closest('[data-close]')) {
        this.closeDrawer();
        return;
      }

      const clear = target.closest('[data-clear]');
      if (clear) {
        event.preventDefault();
        const params = new URLSearchParams();
        const sort = this.querySelector('[data-sort]');
        if (sort) params.set('sort_by', sort.value);
        this.update(params);
        return;
      }

      const more = target.closest('[data-more]');
      if (more) {
        const details = more.closest('details');
        const expanded = details.classList.toggle('is-expanded');
        more.textContent = expanded ? more.dataset.labelLess : more.dataset.labelMore;
        return;
      }

      const loadMore = target.closest('[data-load-more]');
      if (loadMore) {
        event.preventDefault();
        this.loadMore(loadMore);
      }
    }

    onKeyup(event) {
      if (event.key === 'Escape' && this.classList.contains('is-drawer-open')) this.closeDrawer();
    }

    onPopState() {
      this.update(new URLSearchParams(window.location.search), false);
    }

    buildParams() {
      const params = new URLSearchParams();
      const form = this.querySelector('[data-filter-form]');
      if (form) {
        for (const [key, value] of new FormData(form)) {
          if (value !== '') params.append(key, value);
        }
      }
      const sort = this.querySelector('[data-sort]');
      if (sort) params.set('sort_by', sort.value);
      return params;
    }

    fetchSection(url) {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.sectionId);
      return fetch(target.toString())
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector(`tp-mad-colecao[data-section-id="${this.sectionId}"]`);
        });
    }

    async update(params = this.buildParams(), pushState = true) {
      const query = params.toString();
      const url = `${window.location.pathname}${query ? `?${query}` : ''}`;
      const requestId = ++this.requestId;
      this.classList.add('is-loading');

      try {
        const next = await this.fetchSection(url);
        if (requestId !== this.requestId || !next) return;
        this.render(next);
        if (pushState) window.history.pushState({}, '', url);
      } catch (error) {
        window.location.href = url;
      } finally {
        if (requestId === this.requestId) this.classList.remove('is-loading');
      }
    }

    render(next) {
      const results = this.querySelector('[data-results]');
      const nextResults = next.querySelector('[data-results]');
      if (results && nextResults) results.innerHTML = nextResults.innerHTML;

      const nextCount = next.querySelector('[data-count]');
      if (nextCount) {
        this.querySelectorAll('[data-count]').forEach((count) => (count.textContent = nextCount.textContent));
      }

      const applyText = this.querySelector('[data-apply-text]');
      const nextApplyText = next.querySelector('[data-apply-text]');
      if (applyText && nextApplyText) applyText.textContent = nextApplyText.textContent;

      this.querySelectorAll('[data-clear]').forEach((link) => {
        const nextLink = next.querySelector('[data-clear]');
        if (nextLink) link.href = nextLink.getAttribute('href');
      });

      const sort = this.querySelector('[data-sort]');
      const nextSort = next.querySelector('[data-sort]');
      if (sort && nextSort && sort.value !== nextSort.value) {
        sort.value = nextSort.value;
        const label = this.querySelector('[data-sort-label]');
        if (label) label.textContent = sort.selectedOptions[0].textContent.trim();
      }

      this.renderFilters(next);
    }

    // Troca o conteúdo dos grupos mantendo o que o cliente abriu/fechou e o foco
    renderFilters(next) {
      const form = this.querySelector('[data-filter-form]');
      const nextForm = next.querySelector('[data-filter-form]');
      if (!form || !nextForm) return;

      const state = {};
      form.querySelectorAll('details[data-filter]').forEach((details) => {
        state[details.dataset.filter] = {
          open: details.open,
          expanded: details.classList.contains('is-expanded'),
        };
      });
      const focusedId = form.contains(document.activeElement) ? document.activeElement.id : null;

      form.innerHTML = nextForm.innerHTML;

      form.querySelectorAll('details[data-filter]').forEach((details) => {
        const saved = state[details.dataset.filter];
        if (!saved) return;
        details.open = saved.open;
        if (saved.expanded) {
          details.classList.add('is-expanded');
          const more = details.querySelector('[data-more]');
          if (more) more.textContent = more.dataset.labelLess;
        }
      });

      if (focusedId) document.getElementById(focusedId)?.focus();
    }

    async loadMore(button) {
      if (button.classList.contains('loading')) return;
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');

      try {
        const next = await this.fetchSection(button.href);
        const grid = this.querySelector('[data-grid]');
        const nextGrid = next && next.querySelector('[data-grid]');
        if (!grid || !nextGrid) throw new Error('Grade não encontrada');

        const firstNew = nextGrid.firstElementChild;
        grid.append(...nextGrid.children);

        const wrapper = button.closest('[data-more-wrapper]');
        const nextWrapper = next.querySelector('[data-more-wrapper]');
        if (nextWrapper) wrapper.replaceWith(nextWrapper);
        else wrapper.remove();

        const firstLink = firstNew && firstNew.querySelector('a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      } catch (error) {
        window.location.href = button.href;
      } finally {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
      }
    }

    openDrawer() {
      if (!this.drawer) return;
      this.classList.add('is-drawer-open');
      this.drawer.setAttribute('role', 'dialog');
      this.drawer.setAttribute('aria-modal', 'true');
      this.openButton?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tp-mad-colecao-lock');
      this.drawer.querySelector('[data-close]')?.focus();
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.classList.remove('is-drawer-open');
      this.drawer.removeAttribute('role');
      this.drawer.removeAttribute('aria-modal');
      this.openButton?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tp-mad-colecao-lock');
      this.openButton?.focus();
    }
  }

  customElements.define('tp-mad-colecao', TpMadColecao);
})();
